.wrapper {
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  > svg {
    width: 100%;
    height: auto;
  }

  &.sm {
    height: var(--cms-icon-size-sm);
    width: var(--cms-icon-size-sm);
  }
  &.md {
    height: var(--cms-icon-size-md);
    width: var(--cms-icon-size-md);
  }
  &.xl {
    height: var(--cms-icon-size-xl);
    width: var(--cms-icon-size-xl);
  }
  &.xxl {
    height: var(--cms-icon-size-xxl);
    width: var(--cms-icon-size-xxl);
  }
  &.xxxl {
    height: var(--cms-icon-size-xxxl);
    width: var(--cms-icon-size-xxxl);
  }
}
